module.exports = __webpack_public_path__ + "img/star_cup.28d6e738.png";